
var cartData;
var checkout_button = "input[name='checkout'], button[name='checkout'], [href$='checkout'], #PLW_checkout_button, #CartDrawer-Checkout";
// var isNotParentMove = true;
var deposit_selected = true;
function set_payment_option(th) {
  document.getElementById("PLW_purchase-option-info-wrapper").style.display = 'none';
  if (th.id === "PLW_purchase-option-deposit-input") {
    document.getElementById("PLW_purchase-option-info-wrapper").style.display = 'block';
  }
}

function createProductPageDraftOrder(){
 const current_variant_id = document.querySelector('.product-variant-id').value;
const quantityInput = document.querySelector("input[name='quantity']");


    // Fetch the product data using the URL pattern
    const productHandle = window.location.pathname.split('/').pop(); // Extract product handle from URL
    const productUrl = `${window.Shopify.routes.root}products/${productHandle}.js`;

    document.querySelectorAll(checkout_button).forEach(function (element) {
        element.addEventListener("click", function (event) {
            event.preventDefault(); //
      

    fetch(productUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch product data');
            }
            return response.json();
        })
        .then(product => {
            // Find the current variant using the variant ID
            const variant = product.variants.find(v => v.id == current_variant_id);

            if (!variant) {
                alert('Variant not found for the current product!');
                return;
            }

         

            // Preparing cartData for the draft order
            const cartData = {
               
                note: "",
                attributes: {},
                original_total_price: variant.price * quantityInput.value,
                total_price: variant.price * quantityInput.value,
                total_discount: 0,
                total_weight: product.grams,
                item_count:  quantityInput.value,
                items: [
                    {
                        id: variant.id,
                        properties: {}, // Additional properties if required
                        quantity: quantityInput.value,
                        variant_id: variant.id,
                        key: `${variant.id}:product-page-key`,
                        title: product.title,
                        price: variant.price,
                        original_price: variant.price,
                       
                        line_price: variant.price,
                        original_line_price: variant.price,
                        total_discount: 0,
                        discounts: [],
                        final_price: variant.price,
                        final_line_price: variant.price,
                        product_id: product.id
                    }
                ],
                requires_shipping: true,
               
                items_subtotal_price: variant.price * quantityInput.value,
                cart_level_discount_applications: []
            };


          //calculating discount


            const label = document.getElementById("PLW_purchase-option-label");
            const planDescription = label?.getAttribute("data-plan-description");

             let discountInfo = planDescription.split("|");
          let discount_amount = discountInfo.slice(-1).pop();


        
            discount_amount = "40";
         

           // let discount_info = planDescription;

           // let discount_amount = discount_info.slice(-1).pop();

            let discounted_price = cartData.items[0].discounted_price/100;

            if(discount_amount.includes("%")){
              discount_amount = Number(discount_amount.replace("%", ''));

              var new_discounted_price = (discount_amount/100) * discounted_price;
              
            }else{
              discount_amount = Number(discount_amount);
              
              var new_discounted_price = discount_amount - discounted_price;
            }

            cartData.items[0].discounted_price = new_discounted_price*100;

          var amount_left = (variant.price - new_discounted_price*100)/100;
           cartData.note = `COD Amount : ${amount_left}`;

          
         

                const data = {
                message: "Checkout button clicked",
                cartData: JSON.stringify(cartData),
                action: "create_draft_order_cart",
                purchase_option: "20-percentage",
                isCartDiscount: true
            };

          
         // alert(JSON.stringify(cartData));

          
          //  console.log("Sending Draft Order Data:", data);

            // Send the draft order request
             fetch('/apps/PLW/deposit', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data)
              })

                
              .then(response => {
                  if (!response.ok) {
                      throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  return response.json(); // Parse JSON response if applicable
              })
              .then(responseData => {

                  if(typeof responseData.success.invoice_url !== "undefined"){
                   window.location = responseData.success.invoice_url;
                  }
                  console.log('Request successful:', responseData);
              })
              .catch(error => {
                  console.error('Request failed:', error);
              });
               
        })
        // .catch(error => {
        //     console.error("Error fetching product data:", error);
        //     alert("Unable to fetch product data. Please try again.");
        // });
        })});

}

function createProductPageDraftOrderCOD(){
 const current_variant_id = document.querySelector('.product-variant-id').value;
const quantityInput = document.querySelector("input[name='quantity']");


    // Fetch the product data using the URL pattern
    const productHandle = window.location.pathname.split('/').pop(); // Extract product handle from URL
    const productUrl = `${window.Shopify.routes.root}products/${productHandle}.js`;

    fetch(productUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch product data');
            }
            return response.json();
        })
        .then(product => {
            // Find the current variant using the variant ID
            const variant = product.variants.find(v => v.id == current_variant_id);

            if (!variant) {
                alert('Variant not found for the current product!');
                return;
            }

         

            // Preparing cartData for the draft order
            const cartData = {
               
                note: "",
                attributes: {},
                original_total_price: variant.price * quantityInput.value,
                total_price: variant.price * quantityInput.value,
                total_discount: 0,
                total_weight: product.grams,
                item_count:  quantityInput.value,
                items: [
                    {
                        id: variant.id,
                        properties: {}, // Additional properties if required
                        quantity: quantityInput.value,
                        variant_id: variant.id,
                        key: `${variant.id}:product-page-key`,
                        title: product.title,
                        price: variant.price,
                        original_price: variant.price,
                       
                        line_price: variant.price,
                        original_line_price: variant.price,
                        total_discount: 0,
                        discounts: [],
                        final_price: variant.price,
                        final_line_price: variant.price,
                        product_id: product.id
                    }
                ],
                requires_shipping: true,
               
                items_subtotal_price: variant.price * quantityInput.value,
                cart_level_discount_applications: []
            };


          //calculating discount


            const label = document.getElementById("PLW_purchase-option-label");
            const planDescription = label?.getAttribute("data-plan-description");

             let discountInfo = planDescription.split("|");
          let discount_amount = discountInfo.slice(-1).pop();


        
            discount_amount = "20";
         

           // let discount_info = planDescription;

           // let discount_amount = discount_info.slice(-1).pop();

            let discounted_price = cartData.items[0].discounted_price/100;

            if(discount_amount.includes("%")){
              discount_amount = Number(discount_amount.replace("%", ''));

              var new_discounted_price = (discount_amount/100) * discounted_price;
              
            }else{
              discount_amount = Number(discount_amount);
              
              var new_discounted_price = discount_amount - discounted_price;
            }

            cartData.items[0].discounted_price = new_discounted_price*100;

          var amount_left = (variant.price - new_discounted_price*100)/100;
           cartData.note = `Due amount: ${amount_left}`;


                const data = {
                message: "Checkout button clicked",
                cartData: JSON.stringify(cartData),
                action: "create_draft_order_cart",
                purchase_option: "20-percentage",
                isCartDiscount: true
            };

          
         // alert(JSON.stringify(cartData));

          
          //  console.log("Sending Draft Order Data:", data);

            // Send the draft order request
             fetch('/apps/PLW/deposit', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data)
              })

                
              .then(response => {
                  if (!response.ok) {
                      throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  return response.json(); // Parse JSON response if applicable
              })
              .then(responseData => {

                  if(typeof responseData.success.invoice_url !== "undefined"){
                   window.location = responseData.success.invoice_url;
                  }
                  console.log('Request successful:', responseData);
              })
              .catch(error => {
                  console.error('Request failed:', error);
              });
               
        })
        // .catch(error => {
        //     console.error("Error fetching product data:", error);
        //     alert("Unable to fetch product data. Please try again.");
        // });
  

}

document.addEventListener("DOMContentLoaded", function () {



const currentURL = window.location.href;

// Check if the URL contains '/cart'
if (!currentURL.includes('/cart')) {

   let purchaseOptionsHeading = document.querySelector("#PLW-product-wrapper h3");
    if (purchaseOptionsHeading) {
        purchaseOptionsHeading.textContent = "Opciones de Compra (Preventa)";
    }
      let shopifybutton = document.querySelector('.shopify-payment-button__button');

  
 shopifybutton.style.display = 'none';
//     const fullradioButton = document.getElementById('PLW_purchase-option-full');
//   const depositradioButton = document.getElementById('PLW_purchase-option-deposit-input');
 
 
 
//     fullradioButton.addEventListener('change', () => {
     
//       if (fullradioButton.checked) {
      
//         deposit_selected = false;
        
      
//         const payLaterButton = document.getElementById('paylater_button');
       
   
        
//        payLaterButton.style.display = 'none';
//        shopifybutton.style.display = 'block';


//       }
//     });

// depositradioButton.addEventListener('change', () => {
   
//       if (depositradioButton.checked) {
//         // Call the set_payment_option function when the radio button is selected
//          console.log("deposit selected");
//         const payLaterButton = document.getElementById('paylater_button');
      
  
        
//         payLaterButton.style.display = 'block';
//         shopifybutton.style.display = 'none';

        
//          deposit_selected = true;


//       }
//     });

//   shopifybutton.style.display = 'none';
//   const radioInput = document.getElementById('PLW_purchase-option-deposit-input');
//    const PLW_BLOCK = document.querySelector('#PLW-block');


  
    

//       // Check if the radio input is selected
  
//         // Create a new button
//         const addButton = document.createElement('button');
//         addButton.name = 'add';
//         addButton.textContent = 'Comprar ahora';
//         addButton.type ="button";
//         addButton.className = 'shopify-payment-button__button shopify-payment-button__button--unbranded';
//            addButton.id = 'paylater_button'; 

          

//         // Append the button to the container
//        PLW_BLOCK.insertAdjacentElement('afterend',addButton);

        //    const codbutton = document.createElement('button');
        // codbutton.name = 'add';
        // codbutton.textContent = 'Buy COD';
        // codbutton.type ="button";
        // codbutton.className = 'shopify-payment-button__button shopify-payment-button__button--unbranded';
        //    codbutton.id = 'cod_button'; 

          

        // Append the button to the container
      //  PLW_BLOCK.insertAdjacentElement('afterend',codbutton);
      
  //  });

document.querySelectorAll("#paylater_button").forEach(function (element) {
  element.addEventListener("click", function (event) {
    // Prevent the default behavior
    event.preventDefault();

    // Stop the event from propagating further
    event.stopPropagation();

    if(!deposit_selected){
       window.location.href = "/checkout";
    }else{
          createProductPageDraftOrder(); 
    }

  });
});

document.querySelectorAll("#cod_button").forEach(function (element) {
  element.addEventListener("click", function (event) {
    // Prevent the default behavior
    event.preventDefault();

    // Stop the event from propagating further
    event.stopPropagation();

   // console.log("abc");

    // Ensure no other navigation happens
   // return false;

    // Uncomment to call your custom function
     createProductPageDraftOrderCOD();
  });
});


}

  
  

document.querySelectorAll(checkout_button).forEach(function (element) {
        element.addEventListener("click", function (event) {

          
            event.preventDefault(); // Prevent default action if needed (e.g., form submission or navigation)

          console.log("clicked");
    fetch('/cart.js')
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse the response as JSON
    })
    .then(data => {

      var is_paylater = false;
        // Process the cart data as needed
        data.items.forEach((item, index) => {
        console.log(item);

        if(typeof item.selling_plan_allocation !== "undefined"){
          is_paylater = true;
            let discount_info = item.selling_plan_allocation.selling_plan.description.split("|");

            let discount_amount = discount_info.slice(-1).pop();

            let discounted_price = item.discounted_price/100;

            if(discount_amount.includes("%")){
                discount_amount = Number(discount_amount.replace("%", ''));

                var new_discounted_price = (discount_amount/100) * discounted_price;
            
            }else{
                discount_amount = Number(discount_amount);
            
                var new_discounted_price = discount_amount ;
            }

            data.items[index].discounted_price = new_discounted_price*100;

            console.log('Cart data fetched successfully:', data);
            
        }
          
        });

        cartData = data;

      
    

            const purchase_option = document.querySelector('input[name="attributes[_PLW_cart_purchase_option]"]:checked')?.value;

     

            if(!is_paylater){
              window.location = "/checkout";
            }
          
            // return false;

            // Prepare the data to send
            const new_data = {
                message: "Checkout button clicked",
                cartData: JSON.stringify(cartData),
                action: "create_draft_order_cart",
                purchase_option: "100-percentage",
                isCartDiscount: true
            };

          console.log(new_data);

         

            fetch('/apps/PLW/deposit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new_data)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json(); // Parse JSON response if applicable
            })
            .then(responseData => {

                if(typeof responseData.success.invoice_url !== "undefined"){
                    window.location = responseData.success.invoice_url;
                }
                console.log('Request successful:', responseData);
            })
            .catch(error => {
                console.error('Request failed:', error);
            });

    })
    .catch(error => {
        console.error('Failed to fetch cart data:', error);
    });

        });
    });
});
